import { Injectable, inject } from '@angular/core';

import { GroupStoreSelectors, MemberGroupStoreActions, MemberUserStoreActions } from '@era/stores';
import { Store } from '@ngrx/store';
import { Group } from '@rocksoft/security-sdk';
import { Observable } from 'rxjs';
import { filter, first, map, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class GroupMemberResolver {
  private readonly store = inject(Store);

  resolve(): Observable<boolean> {
    return this.store.select(GroupStoreSelectors.selectCurrentGroup).pipe(
      filter((x: Group) => x !== undefined),
      tap((x: Group) => {
        this.store.dispatch(MemberUserStoreActions.MemberUserResolverActions.memberUsersRequested({ group: x }));
        this.store.dispatch(MemberGroupStoreActions.MemberGroupResolverActions.memberGroupsRequested({ group: x }));
      }),
      map(() => true),
      first()
    );
  }
}
